<template mlns="http://www.w3.org/1999/html">
  <div v-loading="initLoading">
  <div style="padding: 20px;position: relative">
    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }" >数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/ServiceChargeWallet' }" >服务费账户明细</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="font-size: 25px;margin-top: 10px;">
      <p>服务费账户明细</p>
    </div>
    <template>
      <div v-show="invoiceBank.jb_wallet" class="el-card box-card">
        <div class="el-card__header cus-header">
          <slot name="header">充值至基础账户</slot>
        </div>
        <div class="el-card__body" style="padding: 0 10px">
          <div class="text">
            <span>{{invoiceBank.jb_wallet}}</span>
          </div>
        </div>
      </div>
    </template>
    <template>
      <div v-show="invoiceBank.jb_wallet&&suppliers[0].methodCount === 0" class="el-card box-card" style="right: 1.5%">
        <div class="el-card__header cus-header">
          <slot name="header">充值至服务费账户</slot>
        </div>
        <div class="el-card__body" style="padding: 0px 10px">
          <div class="text">
            <span>公司名称：上海橙籽维管信息技术有限公司<br/>开户银行：建设银行上海大连路支行<br/>银行账户：31050175410000000956-0002</span>
          </div>
        </div>
      </div>
    </template>
    <div style="width: 100%; font-family: 微软雅黑; font-size: 25px">
      <el-row>
        <el-col :span="8">
          <el-form :model="ruleForm" status-icon label-width="100px" style="margin-top: 10px;width: 300px" >
            <el-form-item label="计费月份" style="width: 700px">
              <el-date-picker
                v-model="ruleForm.startDate"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                placeholder="开始日期"
                :picker-options="pickerOptions0">
              </el-date-picker>
              <el-date-picker
                v-model="ruleForm.endDate"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                placeholder="结束日期"
                :picker-options="pickerOptions1">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="供应商">
              <el-select popper-class="el-select" v-model="supplier" multiple value-key="id" placeholder="必选"  style="width: 400px">
                <select-all-option v-model="supplier" :data="suppliers" :autoSelect="true"/>
                <el-option
                  v-for="item in suppliers"
                  :key="item.id"
                  :label="item.name"
                  :value='item'>
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-bottom: -17px">
        <el-col :span="8"><div class="grid-content bg-purple" style="margin-left: 10vw">
          <el-button style="color: white; letiant:'outlined';border-color: #FF6633; background-color: #FF6633;margin-bottom: 10px"   :loading="loading" @click="Channel">确定</el-button>
          <el-button style="color: white; letiant:'outlined';border-color: #FF6633; background-color: #FF6633;margin-bottom: 10px"   :disabled="tableData.length==0" @click="exportExcel">导出excel</el-button>
        </div></el-col>
      </el-row>
    </div>
    <div style="position: relative">
      <el-table
        :data="tableData"
        id = "tableData"
        style="margin-top: 20px"
        :max-height="600"
        border>
        <el-table-column
          prop="supplierName"
          width="200px"
          align="center"
          label="供应商名称">
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="type"-->
<!--          width="180px"-->
<!--          align="center"-->
<!--          label="加减">-->
<!--          <template slot-scope="scope">-->
<!--            <span style="white-space:pre-line;">{{scope.row.type==0?"加":"减"}}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column
          prop="description"
          align="center"
          width="250px"
          label="项目描述">
        </el-table-column>
        <el-table-column
          prop="fee"
          align="center"
          width="180px"
          label="金额">
          <template slot-scope="scope">
            <span style="white-space:pre-line;">{{scope.row.type==0?"+"+scope.row.fee:"-"+scope.row.fee}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="balc"
          width="180px"
          label="余额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="createdAt"
          width="180px"
          label="创建时间">
        </el-table-column>
        <el-table-column
          align="center"
          prop="project"
          label="描述">
        </el-table-column>
      </el-table>
    </div>
    <div v-if="dialog" class="v-modal" tabindex="0" style="z-index: 2005;background-color: rgb(122,122,122)"></div>
  </div>
  </div>
</template>

<script>
import {selectServiceChargeWallet, getFinanceSupplierByUserId} from "@/api/ServiceCharge"
import XLSX from "xlsx"
import FileSaver from "file-saver"
import selectAllOption from "@/components/selectAllOption";

export default {
  name: "ServiceChargeWallet",
  components: {selectAllOption},
  data(){
    return{
      value1: [],
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      pickerOptions0: {
        disabledDate: (time) => {
          if(this.stringToDate('2020-08').getTime() > time.getTime())
            return true
          if (this.ruleForm.endDate) {
            return time.getTime() > new Date(this.ruleForm.endDate).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if(this.stringToDate('2020-08').getTime() > time.getTime())
            return true
          if (this.ruleForm.startDate) {
            return (time.getTime() < new Date(this.ruleForm.startDate).getTime() || time.getTime() > Date.now())
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      suppliers: [],
      supplierName: '',
      loading: false,
      tableData: [],
      supplier: [],
      ruleForm : {
        startDate: this.getNowTime(-3),
        endDate: this.getNowTime(0),
        supplierId: [],
        supplierName: ''
      },
      token: "",
      dialog: false,
      invoiceBank: {},   // 收款账户
      initLoading:true
    }
  },
  mounted() {
    this.token = localStorage.getItem('token')
    getFinanceSupplierByUserId(this.token).then(res => {
      if (res.data != null) {
        this.suppliers = res.data
      }
      this.initLoading = false
    }).catch(error => {
      let status = error.response.status;
      if (status == 500){
        this.$notify.error({
          title: '错误',
          message: '查询失败，请联系管理员',
          position: 'bottom-right'
        })
      }
    })
  },
  methods: {
    created(){

    },
    getNowTime (i) {
      let now = new Date()
      let year = now.getFullYear() // 得到年份
      let month = now.getMonth() // 得到月份
      if (month + 1+i <= 0){
        month = 12 + (month + 1+i)
        year += -1
      }else
        month = month + 1+i
      month = month.toString().padStart(2, '0')
      let defaultDate = `${year}-${month}`
      return defaultDate
    },
    stringToDate(str){
      let tempStrs = str.split(" ")
      let dateStrs = tempStrs[0].split("-")
      let year = parseInt(dateStrs[0], 10)
      let month = parseInt(dateStrs[1], 10) - 1
      let date = new Date(year, month)
      return date;
    },
    exportExcel(){
      let  name = this.supplierName + "服务费账户明细"
      let  worBook =XLSX.utils.book_new()
      let table =  document.querySelector("#tableData")
      let fix = document.querySelector('.el-table__fixed-right')
      if (fix)
        table.removeChild(fix)
      let workSheet = XLSX.utils.table_to_sheet(table)
      // table.appendChild(fix)
      console.log(workSheet)
      let s = this.tableData.length
      for(let i = 2;i< s+2;i++){
        let value = workSheet['C'+i].v + ""
        workSheet['C'+i].v = value
        workSheet['C'+i].t = "s"
        if (value.substr(0,1) != "-") {
          workSheet['C'+i].v = "+" + value
        }
      }
      workSheet["!cols"] = [{width:30},{width:25},{width:20},{width:20},{width:30},{width:40}];
      XLSX.utils.book_append_sheet(worBook,workSheet,"服务费")
      let wbout = XLSX.write(worBook, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      })
      let tmpDown = new Blob([wbout], {
        type: "application/octet-stream"
      });
      FileSaver.saveAs(tmpDown, name +"_"+this.ruleForm.startDate+"-"+this.ruleForm.endDate+ ".xlsx")
      return wbout
    },
    Channel(){
      let token = localStorage.getItem('token')
      this.loading = true
      this.ruleForm.supplierId = this.supplier.map(s => s.id)
      this.ruleForm.supplierName = this.supplier.name
      selectServiceChargeWallet(token,this.ruleForm).then(res => {
        let data = res.data
        if(data.code == 200){
          this.tableData = data.date.scwList
          this.supplierName = this.tableData[0].supplierName
          this.invoiceBank = data.date.invoiceBank
          if (this.ruleForm.supplierId.length > 1)
            this.supplierName+="等"
          this.$message.success(data.msg)
        }else{
          this.$notify.error({
            title: '错误',
            message: data.msg,
            position: 'bottom-right'
          })
          this.tableData = []
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500){
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
  },
  filters : {
    'amountFilter': function (val){
      return val.replace("#","")
    }
  }
}
</script>

<style scoped>
body .el-table:before {
  z-index: inherit;
}
.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.text {
  font-size: 14px;
  white-space: pre-line;
  text-align: left;
  line-height: 25px;
}
.box-card {
  z-index: 3 !important;
  /*width: 360px;*/
  position: absolute;
  right: 325px;
  top: 10.5%;
  box-shadow:1px 1px 10px #cccccc;
}
.cus-header {
  padding: 10px 10px;
  background-color: #ef6c00;
  color: white;
}
</style>
